import { memo } from "react";

import type { AuthRequestTimelineItem } from "@/hooks/useChat";
import { OAuthLoginButton } from "../../OAuthLoginButton";
import { MessageFrame } from "./MessageFrame";

interface AuthRequestCardProps {
  item: AuthRequestTimelineItem;
  sessionId?: string;
  onAuthComplete?: (sessionId: string, provider: string) => void;
}

export const AuthRequestCard = memo(function AuthRequestCard(
  props: AuthRequestCardProps,
) {
  return (
    <MessageFrame side="bot" wide>
      <OAuthLoginButton
        sessionId={props.sessionId!}
        provider={props.item.provider}
        displayName={props.item.displayName}
        iconUrl={props.item.iconUrl}
        authStartUrl={props.item.authStartUrl}
        status={props.item.status}
        onAuthComplete={props.onAuthComplete ?? (() => {})}
      />
    </MessageFrame>
  );
});
